module.exports = __webpack_public_path__ + "prod/1.42.2/img/solution2.7605a92a.png";